'use strict';
/* Every page except the home page (which has app.js): bag, product cards, Quick look,
   product gallery, add to bag, FAQ accordions. Same markup and classes as the home page. */
(() => {
  const $ = s => document.querySelector(s);
  const esc = v => String(v ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = cents => new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100).replace('$', 'CA$');
  const sized = (src, w) => { src = src.startsWith('//') ? 'https:' + src : src; return src.replace(/([?&])width=\d+/, '$1width=' + w) + (/[?&]width=/.test(src) ? '' : (src.includes('?') ? '&' : '?') + 'width=' + w); };
  const arrow = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="${d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'}"/></svg>`;
  const close = d => (window.opxCloseDialog || (x => x.close()))(d);

  /* Dialogs */
  document.querySelectorAll('.close-dialog').forEach(b => b.addEventListener('click', () => close(b.closest('dialog'))));
  document.querySelectorAll('dialog:not(#site-menu)').forEach(d => {
    d.addEventListener('click', e => { if (e.target !== d) return; const r = d.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(d); });
    d.addEventListener('cancel', e => { e.preventDefault(); close(d); });
  });
  let toastTimer;
  const toast = m => { const t = $('#toast'); if (!t) return; t.textContent = m; t.classList.add('visible'); clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('visible'), 3000); };

  /* Bag (real Shopify cart) */
  async function refreshCart() {
    try {
      const c = await (await fetch('/cart.js')).json();
      $('#bag-count').textContent = c.item_count;
      $('#bag-button').setAttribute('aria-label', `Open bag, ${c.item_count} item${c.item_count === 1 ? '' : 's'}`);
      return c;
    } catch { return null; }
  }
  async function renderCart() {
    const c = await refreshCart(); if (!c) return;
    $('#bag-items').innerHTML = c.items.length ? c.items.map(i => `<div class="bag-item"><div><strong>${esc(i.product_title)}</strong><span>${money(i.final_line_price)}</span></div><button data-remove-line="${i.key}" aria-label="Remove ${esc(i.product_title)}">Remove</button></div>`).join('')
      : '<div class="bag-empty"><p>Your bag is empty.</p><a class="button outline" href="/collections/all">Browse templates</a></div>';
    $('#bag-summary').innerHTML = c.items.length ? `<div class="bag-total"><span>Total</span><span>${money(c.total_price)}</span></div>` : '';
    $('#checkout-link').hidden = !c.items.length;
  }
  $('#checkout-link')?.setAttribute('href', '/checkout');
  $('#bag-button')?.addEventListener('click', async () => { await renderCart(); $('#bag-dialog').showModal(); });
  $('#bag-items')?.addEventListener('click', async e => {
    const b = e.target.closest('[data-remove-line]'); if (!b) return;
    b.disabled = true;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.removeLine, quantity: 0 }) });
    await renderCart(); $('#bag-dialog .close-dialog').focus();
  });
  async function addToBag(variant, button) {
    const label = button.innerHTML; button.disabled = true; button.textContent = 'Adding…';
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] }) });
      if (!r.ok) throw new Error();
      await refreshCart(); toast('Added to your bag'); button.textContent = 'Added to your bag ✓';
      setTimeout(() => { button.innerHTML = label; button.disabled = false; }, 2600);
    } catch { button.disabled = false; button.textContent = 'Could not add. Try again'; }
  }
  refreshCart();

  /* Mobile bar */
  $('#mobile-categories')?.addEventListener('click', () => window.opxMenu?.open());
  document.querySelectorAll('.search-jump').forEach(b => b.addEventListener('click', () => { location.href = '/search'; }));

  /* Galleries: cards (data-step) and big galleries (data-ql-step / data-ql-go) */
  function showSlide(box, images, i, width) {
    const n = images.length; i = (i + n) % n; box.dataset.i = i;
    const img = box.querySelector('img'), next = sized(images[i], width), pre = new Image(); pre.src = next;
    (pre.decode ? pre.decode() : Promise.resolve()).catch(() => {}).then(() => { if (Number(box.dataset.i) === i) img.src = next; });
    const c = box.querySelector('.slide-count'); if (c) c.textContent = `${i + 1} / ${n}`;
    new Image().src = sized(images[(i + 1) % n], width);
    return i;
  }
  function galleryClick(e, root, images, width) {
    const st = e.target.closest('[data-ql-step],[data-ql-go]'); if (!st || !root.contains(st)) return;
    const box = root.querySelector('.ql-main');
    const i = showSlide(box, images, st.dataset.qlGo !== undefined ? Number(st.dataset.qlGo) : Number(box.dataset.i) + Number(st.dataset.qlStep), width);
    root.querySelectorAll('[data-ql-go]').forEach((b, k) => k === i ? b.setAttribute('aria-current', 'true') : b.removeAttribute('aria-current'));
    root.querySelector(`[data-ql-go="${i}"]`)?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
  document.addEventListener('click', e => {
    const step = e.target.closest('.shop-card [data-step]');
    if (step) { const card = step.closest('.shop-card'); showSlide(card.querySelector('.card-media'), JSON.parse(card.dataset.images), Number(card.querySelector('.card-media').dataset.i) + Number(step.dataset.step), 800); }
  });

  /* Product page */
  const pdp = $('.pdp-gallery');
  if (pdp) {
    const images = JSON.parse(pdp.dataset.images);
    pdp.addEventListener('click', e => galleryClick(e, pdp, images, 1600));
    pdp.addEventListener('keydown', e => { if (['ArrowLeft', 'ArrowRight'].includes(e.key)) pdp.querySelector(`.ql-main [data-ql-step="${e.key === 'ArrowLeft' ? -1 : 1}"]`)?.click(); });
  }
  document.querySelectorAll('[data-pdp-form]').forEach(f => f.addEventListener('submit', e => { e.preventDefault(); addToBag(f.querySelector('[name="id"]').value, f.querySelector('button[type="submit"]')); }));

  /* Quick look */
  const detail = $('#product-detail'), dialog = $('#product-dialog');
  let qlImages = [];
  document.addEventListener('click', async e => {
    const q = e.target.closest('[data-quick]'); if (!q) return;
    q.disabled = true;
    try {
      const p = await (await fetch(`/products/${q.dataset.quick}.js`)).json();
      qlImages = p.images; const n = qlImages.length;
      const tags = p.tags.map(t => t.toLowerCase());
      const apps = [tags.includes('format-excel') && 'Excel', tags.includes('format-google-sheets') && 'Google Sheets'].filter(Boolean).join(' + ');
      dialog.classList.add('ql-dialog');
      detail.innerHTML = `<div class="ql"><div class="ql-gallery"><div class="product-visual has-image ql-main" data-i="0"><img src="${sized(qlImages[0], 1400)}" alt="${esc(p.title)}" width="1400" height="1050">${n > 1 ? `<button type="button" class="slide-btn prev" data-ql-step="-1" aria-label="Previous slide">${arrow(-1)}</button><button type="button" class="slide-btn next" data-ql-step="1" aria-label="Next slide">${arrow(1)}</button><span class="slide-count">1 / ${n}</span>` : ''}</div>${n > 1 ? `<div class="ql-thumbs" role="group" aria-label="All slides">${qlImages.map((s, i) => `<button type="button" data-ql-go="${i}" aria-label="Slide ${i + 1}"${i ? '' : ' aria-current="true"'}><img src="${sized(s, 200)}" alt="" width="200" height="150"></button>`).join('')}</div>` : ''}</div><div class="ql-info"><span class="eyebrow">${esc(p.type || 'TEMPLATE').toUpperCase()}</span><h2 id="detail-title">${esc(p.title)}</h2><div class="detail-price">${money(p.price)} <span style="font:13px var(--body)">one-time price</span></div><ul class="ql-facts"><li>${apps}</li><li>${tags.includes('edition-dark') ? 'Light & Dark editions' : 'Light edition'}</li><li>Worked example + blank copy</li></ul><button class="button primary" data-ql-add="${p.variants[0].id}">Add to bag</button><a class="button outline" href="/products/${p.handle}">Open product page</a><div class="ql-desc">${p.description}</div></div></div>`;
      dialog.setAttribute('aria-labelledby', 'detail-title');
      (window.opxOpenProduct || ((t, d) => d.showModal()))(q.closest('.product-card') || q, dialog);
    } catch { location.href = `/products/${q.dataset.quick}`; }
    q.disabled = false;
  });
  detail?.addEventListener('click', e => {
    const add = e.target.closest('[data-ql-add]'); if (add) { addToBag(add.dataset.qlAdd, add); return; }
    galleryClick(e, detail, qlImages, 1400);
  });
  dialog?.addEventListener('keydown', e => { if (!['ArrowLeft', 'ArrowRight'].includes(e.key) || !$('.ql-main')) return; detail.querySelector(`.ql-main [data-ql-step="${e.key === 'ArrowLeft' ? -1 : 1}"]`)?.click(); });

  /* Sort */
  document.querySelectorAll('[data-sort]').forEach(s => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u; }));

  /* FAQ page: each question (h3) and its answer become an accordion */
  document.querySelectorAll('[data-faq]').forEach(root => {
    const heads = [...root.querySelectorAll('h3')]; if (!heads.length) return;
    const list = document.createElement('div'); list.className = 'faq-list';
    heads[0].before(list);
    heads.forEach(h => {
      const d = document.createElement('details'), s = document.createElement('summary');
      s.innerHTML = `${h.innerHTML}<span aria-hidden="true">+</span>`; d.append(s);
      let n = h.nextElementSibling; while (n && n.tagName !== 'H3') { const nx = n.nextElementSibling; d.append(n); n = nx; }
      h.remove(); list.append(d);
    });
  });
})();
